import type { MouseEvent } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { ActivationSetLeaderCellButtonWrapper } from "./StyledComponents";

export const ActivationSetCellButton = ({
    onClick,
    className,
}: {
    onClick: (e: MouseEvent) => void;
    className: string;
}) => {
    return (
        <ActivationSetLeaderCellButtonWrapper
            onClick={onClick}
            className={className}
            data-automation="activation-set-cell-button"
        >
            <SWReactIcons
                iconName="chev-down"
                iconColor={colorsPalettes.carbon[300]}
            />
        </ActivationSetLeaderCellButtonWrapper>
    );
};
